var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-hader"},[_c('header-left',{staticClass:"item"}),_c('header-content',{staticClass:"items"}),_c('header-right',{staticClass:"item"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }